// extracted by mini-css-extract-plugin
export default {"container":"CookiesPopup_container__oA8hT","popup":"CookiesPopup_popup__RTRJ+","cookiesBtn":"CookiesPopup_cookiesBtn__a-BAH","anchor":"CookiesPopup_anchor__vU9Vn"};